import React from 'react';
import { Link } from 'react-router-dom';

const Navigation: React.FC = () => {
  return (
    <nav>
      <Link id="home" to="/">Home</Link>
      <Link id="schedule" to="/schedule">Schedule</Link>
      <Link id="accommodations" to="/accommodations">Accommodations</Link>
      <Link id="faqs" to="/faqs">FAQs</Link>
      <Link id="rsvp" to="/rsvp">RSVP</Link>
    </nav>
  );
};

export default Navigation;
